import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var AND = 'AND';
var OR = 'OR';
var DETAILS = 'DETAILS';
var DISCLAIMER = 'DISCLAIMER';
var PERCENT_APR_FOR = 'PERCENT_APR_FOR';
var PER_MONTH = 'PER_MONTH';
var MONTHS = 'MONTHS';
var CASH_BACK = 'CASH_BACK';
var CASH_DUE_AT_SIGNING = 'CASH_DUE_AT_SIGNING';
var VIEW_APPLICABLE_VEHICLES = 'VIEW_APPLICABLE_VEHICLES';
var CASH_OFFER_FROM = 'CASH_OFFER_FROM';
var FINANCE_AND_CASH_OFFER_FROM = 'FINANCE_AND_CASH_OFFER_FROM';
var FINANCE_OR_CASH_OFFER_FROM = 'FINANCE_OR_CASH_OFFER_FROM';
var FINANCE_OFFER_FROM = 'FINANCE_OFFER_FROM';
var LEASE_OFFER_FROM = 'LEASE_OFFER_FROM';
var PROMOTION_FROM = 'PROMOTION_FROM';

// Temporary list of labels and the "labelObj" class to replicate labels.get() from ws-scripts
// Needed until <Common/> is broken out of ws-scripts for use in modules
var labels = {
  AND: {
    en: 'and',
    es: 'y',
    fr: 'et'
  },
  OR: {
    en: 'or',
    es: 'o',
    fr: 'ou'
  },
  DETAILS: {
    en: 'Details',
    es: 'Detalles',
    fr: 'Détails'
  },
  DISCLAIMER: {
    en: 'Disclaimer',
    es: 'Exención de responsabilidad',
    fr: 'Avertissement'
  },
  EFFECTIVE_THROUGH_X: {
    en: 'Effective through {{END_DATE}}',
    es: 'En vigencia hasta el {{END_DATE}}',
    fr: 'Efficace jusqu\'au {{END_DATE}}'
  },
  EFFECTIVE_X_THROUGH_X: {
    en: 'Effective {{START_DATE}} through {{END_DATE}}',
    es: 'Efectivo desde el {{START_DATE}} hasta el {{END_DATE}}',
    fr: 'En vigueur {{START_DATE}} à {{END_DATE}}'
  },
  PERCENT_APR_FOR: {
    en: '% APR for',
    es: '% tasa de porcentaje anual',
    fr: "% taux d'intérêt annuel"
  },
  PER_MONTH: {
    en: 'per month',
    es: 'por mes',
    fr: 'par mois'
  },
  MONTHS: {
    en: 'months',
    es: 'meses',
    fr: 'mois'
  },
  CASH_BACK: {
    en: 'cash back',
    es: 'reembolso',
    fr: 'argent en remise'
  },
  CASH_DUE_AT_SIGNING: {
    en: 'cash due at signing',
    es: 'pago en efectivo al firmar',
    fr: 'argent dû au moment de la signature'
  },
  VIEW_APPLICABLE_VEHICLES: {
    en: 'view applicable vehicles',
    es: 'ver vehículos aplicables',
    fr: 'voir les véhicules applicables'
  },
  CASH_OFFER_FROM: {
    en: 'Cash Offer from',
    es: 'Oferta en Efectivo de',
    fr: 'Offre en Espèces de'
  },
  FINANCE_AND_CASH_OFFER_FROM: {
    en: 'APR Finance and Cash Offer from',
    es: 'APR Finance y Oferta en Efectivo de',
    fr: 'APR Offre de Financement et en Espèces de'
  },
  FINANCE_OR_CASH_OFFER_FROM: {
    en: 'APR Finance or Cash Offer from',
    es: 'APR Finance o Oferta en Efectivo de',
    fr: 'APR Offre de Financement ou en Espèces de'
  },
  FINANCE_OFFER_FROM: {
    en: 'APR Finance Offer from',
    es: 'APR Finance Offer de',
    fr: 'APR Finance Offre de'
  },
  LEASE_OFFER_FROM: {
    en: 'Lease Offer from',
    es: 'Oferta de arrendamiento de',
    fr: 'Offre de location de'
  },
  PROMOTION_FROM: {
    en: 'Promotion from',
    es: 'Promoción desde',
    fr: 'Promotion à partir de'
  }
};

var LabelObj = function LabelObj() {
  var _this = this;

  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en_US';

  _classCallCheck(this, LabelObj);

  this.locale = locale;

  this.get = function () {
    var label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    // Return untranslated label by default
    var translatedLabel = label;

    var language = _this.locale.split('_')[0];

    if (labels[label]) {
      if (labels[label][language]) {
        // Label exists for this language
        translatedLabel = labels[label][language];
      } else if (labels[label].en) {
        // Default to English
        translatedLabel = labels[label].en;
      }
    }

    return translatedLabel;
  };
};

var ListingLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ListingLink, _React$Component);

  // TODO: remove constructor when <Common /> is added for labels
  function ListingLink(props) {
    var _this;

    _classCallCheck(this, ListingLink);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ListingLink).call(this, props));
    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass(ListingLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentiveId = _this$props.incentiveId,
          incentiveAccountId = _this$props.incentiveAccountId,
          incentiveName = _this$props.incentiveName,
          condition = _this$props.condition,
          newListingPath = _this$props.newListingPath,
          usedListingPath = _this$props.usedListingPath;
      var url = '';

      if (condition === 'NEW') {
        url = newListingPath;
      } else {
        url = usedListingPath;
      }

      if (url) {
        url = "".concat(url, "?incentiveId=").concat(encodeURIComponent(incentiveId), "&incentiveAccountId=").concat(encodeURIComponent(incentiveAccountId));

        if (condition === 'CERTIFIED') {
          url = "".concat(url, "&compositeType=certified");
        }

        return React.createElement("a", {
          className: "small text-capitalize",
          href: url,
          "data-ga-event": "incentives|click|view inventory",
          "data-incentive-id": incentiveId,
          "data-incentive-name": incentiveName
        }, this.labels.get(VIEW_APPLICABLE_VEHICLES));
      } else {
        return null;
      }
    }
  }]);

  return ListingLink;
}(React.Component);
ListingLink.propTypes = {
  incentiveId: PropTypes.string.isRequired,
  incentiveAccountId: PropTypes.string.isRequired,
  incentiveName: PropTypes.string,
  condition: PropTypes.string,
  newListingPath: PropTypes.string,
  usedListingPath: PropTypes.string,
  locale: PropTypes.string.isRequired
};
ListingLink.defaultProps = {
  incentiveName: '',
  condition: 'NEW',
  newListingPath: null,
  usedListingPath: null
};

function parseIncentiveKey(key) {
  var incentiveInfo = {
    incentiveAccountId: '',
    incentiveId: ''
  };

  if (typeof key === 'string') {
    var keyParsed = key.split('_');

    if (keyParsed.length > 1) {
      incentiveInfo = {
        incentiveAccountId: keyParsed[0],
        incentiveId: keyParsed[1]
      };
    }
  }

  return incentiveInfo;
}
function formatNumber(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';

  if (typeof num !== 'number') {
    return '';
  }

  return new Intl.NumberFormat(locale.replace('_', '-')).format(num);
}
function formatCurrency(num) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en_US';
  var showFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var options = {
    style: 'currency',
    currency: locale.length && locale.indexOf('CA') > -1 ? 'CAD' : 'USD'
  };
  var currencyValue;

  if (typeof num !== 'number') {
    return '';
  }

  if (showFractionDigits) {
    // two fraction digits (aka decimal places) by default
    currencyValue = num;
  } else {
    currencyValue = Math.round(num);
    options.minimumFractionDigits = 0;
  }

  return new Intl.NumberFormat(locale.replace('_', '-'), options).format(currencyValue);
}

var TermsList =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TermsList, _React$Component);

  // TODO: remove constructor when <Common /> is added for labels
  function TermsList(props) {
    var _this;

    _classCallCheck(this, TermsList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TermsList).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass(TermsList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          incentiveTerms = _this$props.incentiveTerms,
          locale = _this$props.locale;
      var termsList = null;

      if (incentiveTerms && incentiveTerms.length) {
        var terms;
        incentiveTerms.forEach(function (item) {
          terms = React.createElement(React.Fragment, null, terms, React.createElement("li", {
            className: "list-group-item p-0 pb-1"
          }, "".concat(formatNumber(item.value, locale)).concat(_this2.labels.get(PERCENT_APR_FOR), " ").concat(item.term, " ").concat(_this2.labels.get(MONTHS))));
        });
        termsList = React.createElement("ul", {
          className: "list-group list-group-flush mt-4"
        }, terms);
      }

      return termsList;
    }
  }]);

  return TermsList;
}(React.Component);
TermsList.propTypes = {
  incentiveTerms: PropTypes.arrayOf(PropTypes.shape({
    term: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
  })),
  locale: PropTypes.string.isRequired
};
TermsList.defaultProps = {
  incentiveTerms: []
};

var SpecificDetails =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SpecificDetails, _React$Component);

  // TODO: remove constructor when <Common /> is added for labels
  function SpecificDetails(props) {
    var _this;

    _classCallCheck(this, SpecificDetails);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SpecificDetails).call(this, props));
    var locale = _this.props.locale;
    _this.labels = new LabelObj(locale);
    return _this;
  }

  _createClass(SpecificDetails, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          locale = _this$props.locale,
          showEffectiveStartDate = _this$props.prefs.showEffectiveStartDate;
      var details = null;

      if (incentive && incentive.specific) {
        var effectiveDate = incentive.effectiveDate,
            expirationDate = incentive.expirationDate,
            specific = incentive.specific;
        var effectiveDates = React.createElement("p", null, showEffectiveStartDate.toLowerCase() === 'true' ? "".concat(this.labels.get('EFFECTIVE_X_THROUGH_X').replace(/({{\w+_?}})/gm, function (word) {
          if (word === '{{START_DATE}}') return effectiveDate;
          if (word === '{{END_DATE}}') return expirationDate;
        })) : "".concat(this.labels.get('EFFECTIVE_THROUGH_X').replace('{{END_DATE}}', expirationDate)));
        var cashBack = specific.cashOption ? React.createElement("p", null, "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null;
        var cashDue = specific.cashDue ? React.createElement("p", null, "".concat(formatCurrency(specific.cashDue, locale), " ").concat(this.labels.get(CASH_DUE_AT_SIGNING))) : null;
        var payment = specific.monthlyPayment ? React.createElement("p", null, "".concat(formatCurrency(specific.monthlyPayment, locale), " ").concat(this.labels.get(PER_MONTH)), specific.cashOption ? React.createElement(React.Fragment, null, React.createElement("br", null), "".concat(formatCurrency(specific.cashOption, locale), " ").concat(this.labels.get(CASH_BACK))) : null) : '';

        if (specific._type) {
          switch (specific._type) {
            case 'CASH':
              details = React.createElement(React.Fragment, null, cashBack, effectiveDates);
              break;

            case 'FINANCE':
              details = React.createElement(React.Fragment, null, React.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), effectiveDates, cashDue);
              break;

            case 'CASH_AND_FINANCE':
              details = React.createElement(React.Fragment, null, React.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? React.createElement(React.Fragment, null, React.createElement("p", null, this.labels.get(AND)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'CASH_OR_FINANCE':
              details = React.createElement(React.Fragment, null, React.createElement(TermsList, {
                incentiveTerms: specific.terms,
                locale: locale
              }), specific.cashOption ? React.createElement(React.Fragment, null, React.createElement("p", null, this.labels.get(OR)), cashBack) : null, effectiveDates, cashDue);
              break;

            case 'LEASE':
              // TODO: Missing "lease term" field from VCDA
              details = React.createElement(React.Fragment, null, payment, effectiveDates, cashDue);
              break;

            case 'UNDEFINED_TERM':
              // TODO: Missing "apr" field from VCDA
              details = React.createElement(React.Fragment, null, cashBack, effectiveDates, cashDue);
              break;

            default:
              // PROMOTION
              details = effectiveDates;
          }
        }
      }

      return details;
    }
  }]);

  return SpecificDetails;
}(React.Component);
SpecificDetails.propTypes = {
  incentive: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.string,
    offerDetails: PropTypes.string,
    shortTitle: PropTypes.string,
    disclaimer: PropTypes.string,
    effectiveDate: PropTypes.string,
    expirationDate: PropTypes.string,
    conditional: PropTypes.bool,
    make: PropTypes.string,
    condition: PropTypes.string,
    manufacturerOffer: PropTypes.bool,
    specific: PropTypes.object
  }).isRequired,
  locale: PropTypes.string.isRequired
};

var defaultClickEvent = {
  widgetId: '',
  widgetName: 'wsm-incentive-modal',
  widgetState: 'default',
  event: 'widgetUserEvent',
  element: '',
  elementCTA: undefined,
  action: 'clicked',
  result: '',
  fieldValue: undefined,
  formId: undefined,
  formEventId: undefined,
  value: undefined
};

function trackGoogleAnalyticsEvent(eventData) {
  var trackingObject = window.jQuery(document) || {};

  if (Object.keys(trackingObject).length > 0) {
    trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }
}

function viewSpecialsDetailsEvent(widgetName, widgetId, elementCTA) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    element: 'Specials details link',
    elementCTA: elementCTA,
    result: 'Opened dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}
function closeSpecialsDetailsEvent(widgetName, widgetId) {
  var eventData = {
    widgetId: widgetId,
    widgetName: widgetName,
    widgetState: 'Special dialog',
    element: 'Close button',
    result: 'Closed dialog'
  };
  trackGoogleAnalyticsEvent(eventData);
}

var IncentiveModal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(IncentiveModal, _React$Component);

  function IncentiveModal(props) {
    var _this;

    _classCallCheck(this, IncentiveModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IncentiveModal).call(this, props)); // TODO: remove LabelObj when <Common /> is added for labels

    var locale = props.locale;
    _this.labels = new LabelObj(locale);
    _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
    _this.onOpen = _this.onOpen.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(IncentiveModal, [{
    key: "onOpen",
    value: function onOpen() {
      var _this$props = this.props,
          incentive = _this$props.incentive,
          _this$props$widgetInf = _this$props.widgetInfo,
          windowId = _this$props$widgetInf.windowId,
          widgetName = _this$props$widgetInf.widgetName; // Track when modal is opened

      if (incentive && Object.keys(incentive).length > 0) {
        var title = incentive.title;
        viewSpecialsDetailsEvent(widgetName, windowId, title);
      }
    }
  }, {
    key: "onClose",
    value: function onClose() {
      var _this$props2 = this.props,
          onModalClose = _this$props2.onModalClose,
          _this$props2$widgetIn = _this$props2.widgetInfo,
          windowId = _this$props2$widgetIn.windowId,
          widgetName = _this$props2$widgetIn.widgetName;
      onModalClose(); // Track when modal is closed

      closeSpecialsDetailsEvent(widgetName, windowId);
    }
  }, {
    key: "getOfferType",
    value: function getOfferType(specific, manufacturerOffer, make, accountName) {
      var issuer = accountName;

      if (manufacturerOffer) {
        issuer = make;
      }

      var typeHeading = PROMOTION_FROM;

      if (specific && specific._type) {
        switch (specific._type) {
          case 'CASH':
            typeHeading = CASH_OFFER_FROM;
            break;

          case 'FINANCE':
          case 'UNDEFINED_TERM':
            typeHeading = FINANCE_OFFER_FROM;
            break;

          case 'CASH_AND_FINANCE':
            typeHeading = FINANCE_AND_CASH_OFFER_FROM;
            break;

          case 'CASH_OR_FINANCE':
            typeHeading = FINANCE_OR_CASH_OFFER_FROM;
            break;

          case 'LEASE':
            typeHeading = LEASE_OFFER_FROM;
            break;

          default:
            // PROMOTION
            typeHeading = PROMOTION_FROM;
        }
      }

      return "".concat(this.labels.get(typeHeading), " ").concat(issuer);
    }
  }, {
    key: "getIncentiveDetails",
    value: function getIncentiveDetails() {
      var _this$props3 = this.props,
          incentive = _this$props3.incentive,
          newListingPath = _this$props3.newListingPath,
          usedListingPath = _this$props3.usedListingPath,
          account = _this$props3.account,
          locale = _this$props3.locale,
          prefs = _this$props3.prefs;
      var key = incentive.key,
          specific = incentive.specific,
          title = incentive.title,
          shortTitle = incentive.shortTitle,
          offerDetails = incentive.offerDetails,
          make = incentive.make,
          condition = incentive.condition,
          manufacturerOffer = incentive.manufacturerOffer;

      var _parseIncentiveKey = parseIncentiveKey(key),
          incentiveId = _parseIncentiveKey.incentiveId,
          incentiveAccountId = _parseIncentiveKey.incentiveAccountId;

      var offerType = this.getOfferType(specific, manufacturerOffer, make, account.name);
      return React.createElement(React.Fragment, null, React.createElement("h4", {
        className: "mt-2 mb-0 h5",
        "data-testid": "offerType"
      }, offerType), React.createElement("p", {
        className: "mt-0"
      }, title), React.createElement("h4", {
        className: "mt-2 mb-0 h5 text-capitalize"
      }, this.labels.get(DETAILS)), React.createElement("p", null, offerDetails), React.createElement(SpecificDetails, {
        incentive: incentive,
        locale: locale,
        prefs: prefs
      }), React.createElement(ListingLink, {
        incentiveId: incentiveId,
        incentiveAccountId: incentiveAccountId,
        incentiveName: shortTitle,
        condition: condition,
        newListingPath: newListingPath,
        usedListingPath: usedListingPath,
        locale: locale
      }));
    }
  }, {
    key: "getIncentiveDisclaimer",
    value: function getIncentiveDisclaimer(disclaimer) {
      var incentiveDisclaimer = null;

      if (disclaimer) {
        incentiveDisclaimer = React.createElement("div", {
          className: "text-muted small mt-4"
        }, React.createElement("p", null, "".concat(this.labels.get(DISCLAIMER), ": ").concat(disclaimer)));
      }

      return incentiveDisclaimer;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          incentive = _this$props4.incentive,
          isMobile = _this$props4.isMobile,
          isOpen = _this$props4.isOpen;
      var shortTitle = incentive.shortTitle,
          disclaimer = incentive.disclaimer;
      var incentiveDetails = this.getIncentiveDetails();
      var incentiveDisclaimer = this.getIncentiveDisclaimer(disclaimer);
      return React.createElement(Modal, {
        show: isOpen,
        onHide: this.onClose,
        onShow: this.onOpen,
        className: "m-1 ".concat(isMobile ? 'dock-right' : null)
      }, React.createElement(Modal.Header, null, React.createElement(Modal.Title, {
        className: "text-center"
      }, React.createElement("button", {
        type: "button",
        "aria-label": "Close",
        className: "close text-muted",
        onClick: this.onClose
      }, React.createElement("i", {
        className: "ddc-icon ddc-icon-close",
        "aria-hidden": "true"
      })), React.createElement("span", {
        className: "h3 my-0 px-5"
      }, shortTitle))), React.createElement(Modal.Body, null, incentiveDetails, incentiveDisclaimer));
    }
  }]);

  return IncentiveModal;
}(React.Component);
IncentiveModal.propTypes = {
  incentive: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.string,
    offerDetails: PropTypes.string,
    shortTitle: PropTypes.string,
    disclaimer: PropTypes.string,
    effectiveDate: PropTypes.string,
    expirationDate: PropTypes.string,
    conditional: PropTypes.bool,
    make: PropTypes.string,
    condition: PropTypes.string,
    manufacturerOffer: PropTypes.bool,
    specific: PropTypes.object
  }).isRequired,
  widgetInfo: PropTypes.shape({
    windowId: PropTypes.string.isRequired,
    widgetName: PropTypes.string.isRequired,
    deviceType: PropTypes.string.isRequired
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  account: PropTypes.shape({
    name: PropTypes.string,
    id: PropTypes.string
  }).isRequired,
  newListingPath: PropTypes.string,
  usedListingPath: PropTypes.string,
  locale: PropTypes.string,
  prefs: PropTypes.shape({
    showEffectiveStartDate: PropTypes.string
  })
};
IncentiveModal.defaultProps = {
  newListingPath: null,
  usedListingPath: null,
  locale: 'en_US',
  prefs: {
    showEffectiveStartDate: 'true'
  }
};

export { IncentiveModal };
//# sourceMappingURL=es.js.map



//////////////////
// WEBPACK FOOTER
// ./~/wsm-incentive-modal/dist/es.js
// module id = 34
// module chunks = 0